import styled from "styled-components";

export const OnboardingCard = styled.div`
  grid-area: card;
  grid-column: 2/2;
  grid-row: 1/-1;
`;
